<template>
  <div class="pb-2">
    <div v-if="this.loadpage == true" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <div v-if="this.loadpage == false">
      <b-card no-body>
        <b-card-header>
          <h4>รายการลูกค้า</h4>
        </b-card-header>
        <hr class="my-0 mx-2">
        <b-card-body>
          <div>ค้นหาโดย :</div>
          <div class="d-md-flex">
            <v-select
              class="px-0 pb-1 pb-md-0 col-12 col-md-4"
              v-model="searchID"
              :options="searchItem"
              label="text"
            ></v-select>
            <div class="px-0 px-md-1 pb-1 pb-md-0 col-12 col-md-4">
              <b-form-input v-model="searchText"/>
            </div>
            <div class="px-0 col-12 col-md-2">
              <b-button @click="getCustomer()" variant="primary">
                ค้นหา
              </b-button>
            </div>
          </div>
        </b-card-body>
        <b-card-body>
          <div class="text-right">จำนวน : {{totalRows}}</div>
          <b-table
            responsive
            :items="custmerList"
            :fields="customerFields"
            table-class="table-md-responsive text-nowrap"
          >
            <template #cell(no)="data">
              {{(custmerList.findIndex(x => x.customerId == data.item.customerId) + 1) + ((currentPage - 1) * 10)}}
            </template>
            <template #cell(firstName)="data">
              <b-link @click="toDetail(data.item.loginToken)"><u>{{data.value}}</u></b-link>
            </template>
            <template #cell(birthDate)="data">
              {{formatDate_dmy(data.value)}}
            </template>
            <template #cell(approvedBalance)="data">
              {{format_price(data.value)}}
            </template>
            <template #cell(approvedYuan)="data">
              {{format_price(data.value)}}
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="mt-0"
          />
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BFormFile, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput,
  BInputGroupAppend, BButton, BCardBody, BCard, BTabs, BTab, BSpinner, BRow, BCol, BFormRadioGroup,
  BFormCheckbox, BFormTextarea, BLink, BCardHeader, BFormRadio, BCardFooter, BModal, VBModal, BForm,
  BImg, BTable, VBToggle, BTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { formatDate_dmy, format_price } from '@/views/global_function.js'
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";
export default {
  name: 'Taobao2youCustomer',

  components: {
    BSpinner, BCard, BCardBody, BCardHeader, BFormSelect, BFormInput, BTable, BPagination, BLink, BTooltip,
    BButton,

    vSelect,

   },

  data() {
    return {

      // search
      searchID: {text: 'CustomerID', value: 1, req: 'customerID'},
      searchItem: [
        {text: 'CustomerID', value: 1, req: 'customerID'},
        {text: 'ชื่อจริง', value: 2, req: 'customerName'},
        {text: 'ชื่อเล่น', value: 3, req: 'nickName'},
        {text: 'เบอร์โทร', value: 4, req: 'phone'},
        {text: 'Email', value: 5, req: 'email'},
        {text: 'ชื่อผู้รับ', value: 6, req: 'receiverName'},
        {text: 'TaobaoID', value: 7, req: 'taobaoID'},
        {text: 'ระดับลูกค้า', value: 8, req: 'customerLevel'},
        {text: 'Username', value: 9, req: 'username'},
      ],
      searchText: '',

      //table
      custmerList: [],
      customerFields: [
        { key: 'no', label: 'ลำดับ', thClass: 'text-center px-0', tdClass: 'text-center px-0'},
        { key: 'firstName', label: 'ชื่อ', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'lastName', label: 'นามสกุล', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'taobaoReceiveName', label: 'Code', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'approvedBalance', label: 'เงินไทย', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'approvedYuan', label: 'เงินจีน', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'nickName', label: 'ชื่อเล่น', thClass:'text-center', tdClass: 'text-center'},
        { key: 'birthDate', label: 'วันเกิด', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'email', label: 'Email', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'phoneNumber', label: 'เบอร์โทร', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'lineID', label: 'Line ID', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'userId', label: 'Username', thClass: 'text-center', tdClass: 'text-center'},
        
      ],
      perPage: 10,
      currentPage: 1,
      totalRows: 1,

      //
      loadpage: true
    };
  },

  watch: {
    searchID() {
      console.log(this.searchID);
      
    },
    async currentPage() {
      await this.getCustomer()
    }
  },

  async created() {
    await this.getCustomer()
    this.loadpage = false
  },
  

  methods: {
    formatDate_dmy, format_price,
    async getCustomer() {
      var skip = 0
      skip = (this.currentPage - 1) * 10

      var data = {}
      if (this.searchText != '') {
        JSON.stringify(
          data[this.searchID.req] = this.searchText,
          data.skip = skip,
          data.take = 10
        )
      } else {
        JSON.stringify(
          data.skip = skip,
          data.take = 10
        )
      }

      let response = await axios.post(
        taobaoService_dotnet  + 'app/Customer/get-customer-list',
        // 'https://localhost:5001/app/Customer/get-customer-list',
        data,
        { headers: header_token }
      )
      this.totalRows = response.data.totalRows
      this.custmerList = response.data.items
    },
    toDetail(token) {
      console.log(token);
      window.open("/admin/customer-detail?id=" + token);
      
    }
  },
};
</script>

<style scoped>

</style>